import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  /* eslint-disable-next-line @angular-eslint/directive-selector */
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-kit-tabs-content',
  templateUrl: 'tabs-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsContentComponent {
  constructor() {}
}
